export default __webpack_public_path__ + "static/media/Component-3–1-light.41be02a3.svg";